import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import randomId from 'random-id';
import { Tooltip } from 'reactstrap';
import Icon from '../icon/icon';

export default class IconTooltip extends Component {
  static defaultProps = {
    placement: 'top'
  };
  state = {
    tooltipVisible: false
  };

  constructor(props) {
    super(props);

    this.id = randomId(20, 'a');
  }

  toggleTooltip = () => {
    this.setState({
      tooltipVisible: !this.state.tooltipVisible
    });
  };

  render() {
    const { icon, placement, text, className, onClick, delay } = this.props;

    return (
      <Fragment>
        <Icon id={this.id} icon={icon} className={cn(className, onClick ? 'pointer' : null)} onClick={onClick} />
        <Tooltip
          placement={placement}
          isOpen={this.state.tooltipVisible}
          target={this.id}
          toggle={this.toggleTooltip}
          delay={delay || 500}
        >
          <span>{text}</span>
        </Tooltip>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/iconTooltip/iconTooltip.jsx